export default "__VITE_ASSET__CbnG_1jY__"